import React from 'react'
import { TABLA_CARGA_BUQUES } from '../../../../config/tables'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'

function TablaCargaBuquesView () {
  return (
    <MuiTable id={TABLA_CARGA_BUQUES} />
  )
}

export default TablaCargaBuquesView
